/**
 * Rendered first in <body> (see __root.tsx). It originally covered the gap
 * opened by loading the stylesheet with media="print" — that approach is gone
 * (React drops the lowercase `onload` that was meant to swap it back, so the
 * site rendered unstyled), and the stylesheet is render-blocking again. With
 * CSS and markup now arriving together there is no unstyled gap left to hide,
 * so this is branding rather than a fix; it can be removed outright.
 *
 * Plain JSX, not dangerouslySetInnerHTML — this component's output never
 * changes across re-renders (no props, no state), so React never re-diffs
 * this subtree once painted, meaning the removal script below is free to
 * mutate/remove the real DOM node without React ever trying to "correct" it
 * back. The inline <style>/<script> can't depend on the Tailwind stylesheet
 * (the whole point is running before that loads), so colors/keyframes are
 * hand-duplicated from src/styles.css / logo.tsx's AnimatedLogoMark.
 */
export function SplashScreen() {
	return (
		<div
			id="ma-splash"
			style={{
				position: "fixed",
				inset: 0,
				zIndex: 2147483647,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				background: "#f4f6f4",
				// Pure-CSS fallback: hides itself even if the removal script below
				// never runs (JS disabled, script error, etc.).
				animation: "ma-splash-auto-hide .01s linear 4s forwards",
			}}
		>
			<svg
				viewBox="0 0 47 43"
				width={56}
				height={51}
				fill="none"
				aria-hidden="true"
			>
				<path
					d="M23.1784 18.8657L16.2247 18.8672L11.5885 42.4485H0V0H11.5885L23.1784 18.8657Z"
					fill="#152C4C"
					style={{ animation: "ma-splash-breathe 1.8s ease-in-out infinite" }}
				/>
				<path
					d="M23.1777 42.4491L28.9723 18.8662H40.5616L46.3562 42.4491H23.1777Z"
					fill="#17A6B1"
					style={{
						animation: "ma-splash-breathe 1.8s ease-in-out .4s infinite",
					}}
				/>
				<path
					d="M34.7706 0L25.498 5.90497L34.7706 11.7914L44.0402 5.90497L34.7706 0Z"
					fill="#17A6B1"
					style={{
						animation: "ma-splash-spin 3.2s linear infinite",
						transformOrigin: "34.77px 5.9px",
					}}
				/>
			</svg>
			<style>{`
				@keyframes ma-splash-breathe { 0%, 100% { opacity: .45 } 50% { opacity: 1 } }
				@keyframes ma-splash-spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }
				@keyframes ma-splash-auto-hide { to { opacity: 0; visibility: hidden; pointer-events: none } }
			`}</style>
			<script>{`
				(function () {
					function hide() {
						var el = document.getElementById("ma-splash");
						if (!el) return;
						el.style.transition = "opacity .25s ease";
						el.style.opacity = "0";
						el.style.pointerEvents = "none";
						setTimeout(function () {
							if (el && el.parentNode) el.parentNode.removeChild(el);
						}, 300);
					}
					if (document.readyState === "complete") hide();
					else window.addEventListener("load", hide);
				})();
			`}</script>
		</div>
	);
}
